import { createSelector } from 'reselect';

import { getChannelForWidget } from 'shared/selectors/channels';


const getSelectedVideoIdFromStore = state => state.selectedVideoId;
const getFeaturedVideoId = createSelector([getChannelForWidget], channel => _.get(channel, 'featuredItem'));
const getFirstVideoFromList = (state, listType) => (_.get(state.lazyVideoLists[listType], 'idChunks[0][0]') || _.get(state.lazyVideoLists[listType], 'videoIds[0]'));

export const getMainVideoId = createSelector(
  [getSelectedVideoIdFromStore, getFeaturedVideoId, getFirstVideoFromList],
  (selectedVideoId, featuredVideoId, firstVideoId) =>
    selectedVideoId || featuredVideoId || firstVideoId
);



// WEBPACK FOOTER //
// ./src/widget/ui-selectors/selected-video-id.js